<template>
  <div class="system-dic-dialog-container">
    <el-dialog
      :title="title"
      :visible.sync="isShowDialog"
      width="450px"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="点位名称" prop="Name">
          <el-input v-model="formData.Name"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="Location">
          <el-input v-model="formData.Location"></el-input>
        </el-form-item>
        <el-form-item label="经营类型" prop="Type">
          <el-select
            v-model="formData.Type"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in typeList"
              :key="item.ItemValue"
              :label="item.ItemText"
              :value="item.ItemValue"
            >
            </el-option>
          </el-select>
          <!-- <el-input v-model="formData.Type"></el-input> -->
        </el-form-item>
        <el-form-item label="描述" prop="Description">
          <el-input v-model="formData.Description"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="Phone">
          <el-input v-model="formData.Phone"></el-input>
        </el-form-item>
        <el-form-item label="经/纬度">
          <el-input placeholder="标记点位获取经纬度" v-model="LngLat" disabled>
            <el-button
              slot="append"
              icon="el-icon-map-location"
              @click="showMap"
            ></el-button>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="纬度" prop="Latitude">
          <el-input v-model="formData.Latitude" disabled></el-input>
        </el-form-item> -->
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="onCancel" size="default">取 消</el-button>
          <el-button
            :loading="btnLoading"
            type="primary"
            @click="onSubmit"
            size="default"
          >
            保存
          </el-button>
        </span>
      </template>
      <el-dialog
        width="50%"
        title="点位标记"
        :visible.sync="innerVisible"
        append-to-body
        @close="closeInnerDialog"
        :close-on-click-modal="false"
      >
        <div class="map-container" v-if="innerVisible">
          <talentMap
            class="talentMap"
            ref="talentMap"
            @getLnglat="getLnglat"
            :marker-items="markerItems"
            @cancel="closeInnerDialog"
          />
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import talentMap from "@/components/map";
import { GetSysDictByCode } from "@/api/SysDictionary/SysDictionary";
import {
  GetMaplocation,
  AddMapLocation,
  PutMaplocation,
} from "@/api/talentMap/index";
export default {
  components: { talentMap },
  data() {
    return {
      isShowDialog: false,
      title: "",
      formData: {
        Name: "",
        Location: "",
        Type: 0,
        Description: "",
        Phone: "",
        Longitude: null,
        Latitude: null,
      },
      rules: {
        Name: [{ required: true, message: "请输入点位名称", trigger: "blur" }],
        Type: [{ required: true, message: "请选择经营类型", trigger: "blur" }],
      },
      innerVisible: false,
      btnLoading: false,
      markerItems: [],
      typeList: [],
    };
  },
  computed: {
    LngLat() {
      if (this.formData.Longitude && this.formData.Latitude) {
        return `${this.formData.Longitude}，${this.formData.Latitude}`;
      }
      return "";
    },
  },
  created() {
    this.HttpQueryDicByCode({ Code: "MapLocation_Type" });
  },
  methods: {
    async HttpQueryDicByCode(params) {
      const response = await GetSysDictByCode(params);
      let res = response.data || {};
      if (res.status == 200) {
        let raw = res.response || [];
        this.typeList = raw;
        console.log("typeList", this.typeList);
        // raw.forEach((o) => {
        //   result[o.ItemValue] = o.ItemText;
        // });
        // this.typeDic = result;
      } else {
        this.$message.error(res.msg);
      }
    },
    async openDialog(formData, title) {
      this.formData = {
        Name: "",
        Location: "",
        Type: 0,
        Description: "",
        Phone: "",
        Longitude: null,
        Latitude: null,
      };
      if (formData.Id) {
        const res = await GetMaplocation({ Id: formData.Id });
        console.log("res", res);
        if (res.data.status == 200 && res.data && res.data.response) {
          this.formData = res.data.response;
          this.formData.Type = Number(this.formData.Type);
        } else {
          this.formData = {
            Name: "",
            Location: "",
            Type: 0,
            Description: "",
            Phone: "",
            Longitude: null,
            Latitude: null,
          };
        }
      }
      if (this.formData.Longitude && this.formData.Latitude) {
        this.markerItems.push(this.formData);
      }
      this.isShowDialog = true;
      this.title = title;
    },
    closeDialog() {
      this.isShowDialog = false;
      this.formData = {
        Name: "",
        Location: "",
        Type: 0,
        Description: "",
        Phone: "",
        Longitude: null,
        Latitude: null,
      };
      this.$emit("refresh");
    },
    showMap() {
      this.innerVisible = true;
    },
    getLnglat(e) {
      console.log("Longitude", e);
      this.formData.Longitude = e.lng;
      this.formData.Latitude = e.lat;
      console.log("formData", this.formData);
    },
    closeInnerDialog() {
      this.innerVisible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          if (this.formData.Id) {
            PutMaplocation(this.formData).then((res) => {
              console.log("res", res);
              if (res.data.status == 200) {
                this.closeDialog();
                this.$message({ type: "success", message: "修改成功" });
                this.btnLoading = false;
              } else {
                this.$message.error(res.data.msg);
              }
            });
          } else {
            AddMapLocation(this.formData).then((res) => {
              if (res.data.status == 200) {
                this.closeDialog();
                this.$message({ type: "success", message: "保存成功" });
                this.btnLoading = false;
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.map-container {
  height: 500px;
  width: 100%;
}
</style>
